const processScopeOptions = [
  {
    name: "My Request Only",
    value: 1,
  },
];

const processStatusOptions = [
  {
    name: "Pending Approval",
    value: 1,
  },
  {
    name: "Pending Submission",
    value: 2,
  },
  {
    name: "Approved",
    value: 3,
  },
  {
    name: "Rejected",
    value: 4,
  },
  {
    name: "System Termination",
    value: 5,
  },
];

export { processScopeOptions, processStatusOptions };
